import { useEffect } from "react";
import { toast } from "sonner";

// Deters casual copying: blocks right-click (removes the Google Lens / "search image"
// context option), image drag/save, Ctrl+S/P, and adds best-effort screenshot deterrents
// (PrintScreen clears clipboard + blurs; screen blurs while the tab is hidden).
export default function ContentProtection() {
  useEffect(() => {
    const onCtx = (e) => { e.preventDefault(); return false; };
    const onDrag = (e) => { if (e.target && e.target.tagName === "IMG") e.preventDefault(); };
    const guard = () => {
      document.body.classList.add("screenshot-guard");
      window.clearTimeout(guard._t);
      guard._t = window.setTimeout(() => document.body.classList.remove("screenshot-guard"), 1500);
    };
    const onKey = (e) => {
      if (e.key === "PrintScreen") {
        try { navigator.clipboard.writeText(" "); } catch { /* ignore */ }
        guard();
        toast.warning("Screenshots are disabled in the Fun Zone.");
      }
      const k = (e.key || "").toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (k === "s" || k === "p")) e.preventDefault();
    };
    const onVis = () => {
      if (document.hidden) document.body.classList.add("screenshot-guard");
      else document.body.classList.remove("screenshot-guard");
    };
    document.addEventListener("contextmenu", onCtx);
    document.addEventListener("dragstart", onDrag);
    document.addEventListener("keydown", onKey);
    document.addEventListener("keyup", onKey);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      document.removeEventListener("contextmenu", onCtx);
      document.removeEventListener("dragstart", onDrag);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("keyup", onKey);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);
  return null;
}
